module.exports = __webpack_public_path__ + "static/media/Hariharan.f4d041a9.png";